import script from "./AIView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AIView.vue?vue&type=script&lang=ts&setup=true"

import "./AIView.vue?vue&type=style&index=0&id=e390e906&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e390e906"]])

export default __exports__